import { gql } from '@apollo/client';

export const ALL_NATIONALITIES = gql`
  query getNationalities($input: NameSearchArgs!) {
    nationalities: getNationalities(input: $input) {
      id
      name
    }
  }
`;
